<template>

    <div id="ambassador-registration" class="master-section submitform-layout section_4">
        <p id="auto-scroll"></p>
        <section class=" row align-items-center px-0 px-md-1 mb-40px mb-md-60px mx-0 mx-md-1">
            <div class="col-12 col-md-6 mx-auto">
                <div class="master-template__form">
                    <p style="font-size: 26px;    color: #212529;
    font-family: 'DM Serif Text';
    font-weight: bold;" class="master-template__form-title">{{ title_form }}</p>
                    <div class="master-template__form-descirption" v-html="description"></div>
                    <form @submit.prevent="submitForm"
                        class="ambassador-custom altform master-template__form-fields master-template__ambassador-fields"
                        :class="{ 'submit_ss': check_sub }"
                        id="ambassador_form"
                        style="max-height: 70vh;
                                overflow-y: auto;
                                overflow-x: hidden;
                                padding: 15px;
                                border: 0.5px solid #c9c2c2;
                                border-radius: 5px;"
                        @click="startLoadRecaptcha"
                        >
                        <FormInput v-model="form.email" @clearError="clearFieldError('email')" label="CONTACT EMAIL"
                            required placeholder="xyz@gmail.com" type="text" :errorMessage="errors.email" />
                        <FormInput v-model="form.name" @clearError="clearFieldError('name')" label="FULL NAME" required
                            placeholder="Denise We" type="text" :errorMessage="errors.name" />
                        <ButtonCheck />
                        <FormInput v-model="form.date" @clearError="clearFieldError('date')" label="Date Of Birth"
                            required placeholder="Date" type="birthday" :minDate="true" :errorMessage="errors.date" formart="2"/>
                        <FormInput v-model="form.phone" prefix="+65" type="phone" required @clearError="clearFieldError('phone')"
                            label="Mobile Number" :errorMessage="errors.phone" />
                        <h4 class="master-template__form--field-set" style="padding-top: 40px;">Social</h4>
                        <FormCheckAccountSocial :error_social="error_social" @setInputValue="setInputOther"  :errorMessage="errors.social" @checkOptions="checkOptions" type="social" :options="socialOptions.options" :title="socialOptions.title"/>
                        <FormCheckAmba @setInputValue="setInputOther" :errorOther="errors?.other_social"  :errorMessage="errors.social_content??errors?.other_social" @checkOptions="checkOptions"  type="social_content" :options="socialOptionContent.options" :title="socialOptionContent.title" :label="socialOptionContent.label"/>
                        <FormCheckAmba @setInputValue="setInputOther" :errorOther="errors?.other_content_format"  :errorMessage="errors.preferred_content??errors?.other_content_format" @checkOptions="checkOptions"  type="preferred_content" :options="contentFormat.options" :title="contentFormat.title" :label="contentFormat.label"/>
                        <GroupButton />
                        <FormCheckAmba @setInputValue="setInputOther" :errorMessage="errors.programme??errors?.other_programme" @checkOptions="checkOptions" type="programme" :options="programmeOptions.options" :title="programmeOptions.title" :label="programmeOptions.label"/>
                        <FormInput style="margin-bottom: 16px;" v-model="form.tell_us" @clearError="clearFieldError('tell_us')" label="In one sentence, tell us why you want to be part of the community."
                        required placeholder="Tel us more" type="text" :errorMessage="errors.tell_us" />
                        <div style="padding-top:0" class="altform-submit-group">
                            <button type="submit" class="button button-submit"
                                fdprocessedid="6043p6"><span class="button__text" style="color: #fff !important;">Submit</span>
                            </button>
                            <div v-if="isSubmitting" class="loading"> </div>
                            <input type="hidden" name="action" value="kform_submit"><input type="hidden" name="form_id"
                                value="ambassador_form"><input type="hidden" name="knonce" value="c5605012e6"><img
                                class="altform-pinner"
                                src="https://skjewellery396.e.wpstage.net/wp-content/themes/SKSG8.7.0/assets/images/spinner.svg"><input
                                type="hidden" name="post_id" value="639642"></div>
                        <div class="altform-message success-message">{{ responseMessage }}</div>
                        <div id="alt-recaptcha">
                            <Recaptcha ref="recaptchaRef" v-if="siteKey_recapcha"  v-model="form.recaptcha" :siteKey="siteKey_recapcha" />
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>
<script lang="ts" setup>
import {computed, onMounted, ref} from 'vue';
import FormInput from "~/components/Career/Forms/FormInput.vue";
import Recaptcha from '~/components/Career/Forms/Recaptcha.vue';
import FormCheckAmba from '~/components/TemplateMaster/FormCheckAmba.vue';
import ButtonCheck from '~/components/TemplateMaster/ButtonCheck.vue';
import GroupButton from '~/components/TemplateMaster/GroupButton.vue';
import FormCheckAccountSocial from '~/components/TemplateMaster/FormCheckAccountSocial.vue';
const { pushToDataLayer, pushPageTypeToDataLayer } = useCustomGtm();
const { $ajax } = useNuxtApp();
const responseMessage = ref('');
const check_sub = ref(false);
const isSubmitting = ref(false);
const recaptchaRef = ref(null);
const props = defineProps({
    data_title: String,
    data_description: String,
    data_key: String,
    data_postId: Number,
});
const checkOptionsSocial = (actions: any) => {
    const data = {
        key: actions.key.trim(),
        label: actions.label,
        value: actions.value,
    };
}
const setInputValue = (actions: any) => {
    const data = {
        key: actions.key.trim(),
        label: actions.label,
        value: actions.value,
    };
    form.value['social'][data.key] = data.value;

};

const setInputOther = (actions: any) => {
    const data = {
        key: actions.key.trim(),
        label: actions.label,
        value: actions.value,
        type: actions.type,
    };

    form.value[actions.key] = data.value;
    errors.value[actions.key] = null;
}
const checkOptions = (actions: {value: string; key: string; label: string; type: string}) => {

    if (Array.isArray(form.value[actions.key])) {
        const index = form.value[actions.key].findIndex(
            (item: {value: string; key: string; label: string; type: string}) => item.value === actions.type
        );

        if (index === -1) {
            form.value[actions.key].push({
                key: actions.key.trim(),
                label: actions.label,
                value: actions.value,
                type: actions.type,
            });
            if(actions.type==="other_social"){
        form.value = {...form.value, [actions.type]: ''};
    }
            if(actions.type==="instagram"){
        form.value = {...form.value, [actions.type]: ''};
    }
            if(actions.type==="tiktok"){
        form.value = {...form.value, [actions.type]: ''};
    }
            if(actions.type==="xiao_hong_shu"){
        form.value = {...form.value, [actions.type]: ''};
    }
            if(actions.type==="youtube"){
        form.value = {...form.value, [actions.type]: ''};
    }
            if(actions.type==="lemon8"){
        form.value = {...form.value, [actions.type]: ''};
    }
            if(actions.type==="douyin"){
        form.value = {...form.value, [actions.type]: ''};
    }
    if(actions.type==="other_programme"){
        form.value = {...form.value, [actions.type]: ''};
    }
    if(actions.type==="other_content_format"){
        form.value = {...form.value, [actions.type]: ''};
    }
            errors.value[actions.key] = null;
        } else {
            form.value[actions.key].splice(index, 1);
            errors.value[actions.key] = null;

            delete errors.value[actions.key];
                if(actions.type==="other_social"){
                    errors.value['other_social'] = null;
                    delete form.value['other_social']
                    delete errors.value['other_social']
                }
                if(actions.type==="instagram"){
                    error_social.value['instagram'] = null;
                    delete form.value['instagram']
                    delete error_social.value['instagram']
                }
                if(actions.type==="tiktok"){
                    error_social.value['tiktok'] = null;
                    delete form.value['tiktok']
                    delete error_social.value['tiktok']
                }
                if(actions.type==="xiao_hong_shu"){
                    error_social.value['xiao_hong_shu'] = null;
                    delete form.value['xiao_hong_shu']
                    delete error_social.value['xiao_hong_shu']
                }
                if(actions.type==="youtube"){
                    error_social.value['youtube'] = null;
                    delete form.value['youtube']
                    delete error_social.value['youtube']
                }
                if(actions.type==="lemon8"){
                    error_social.value['lemon8'] = null;
                    delete form.value['lemon8']
                    delete error_social.value['lemon8']
                }
                if(actions.type==="douyin"){
                    error_social.value['douyin'] = null;
                    delete form.value['douyin']
                    delete error_social.value['douyin']
                }
                if(actions.type==="other_programme"){
                    errors.value['other_programme'] = null;
                    delete form.value['other_programme']
                    delete errors.value['other_programme']
                }
                if(actions.type==="other_content_format"){
                    errors.value['other_content_format'] = null;
                    delete form.value['other_content_format']
                    delete errors.value['other_content_format']
                }
        }
    } else {
    }
};

const socialOptions = {
    'type': 'social',
    'title': 'What is your social handle? ',
    'options': [
    { id: 1,key: 'instagram', label: 'Instagram', value: '', isShowInput: 1 },
    { id: 2,key: 'tiktok', label: 'TikTok', value: '', isShowInput: 1 },
    { id: 3,key: 'xiao_hong_shu', label: 'Xiao Hong Shu (小红书)', value: '', isShowInput: 1 },
    { id: 4,key: 'youtube', label: 'YouTube', value: '', isShowInput: 1 },
    { id: 5,key: 'lemon8', label: 'Lemon8', value: '', isShowInput: 1 },
    { id: 6,key: 'douyin', label: '抖音 (Douyin)', value: '', isShowInput: 1 },
]
}
const socialOptionContent ={
    'type':'social_content',
    'label':'Please specify',
    'title':'Which of the below topics best describes your social content?',
    'options':[
    { id: 7, key: 'fashion_style', label: 'Fashion & Style', value: '', isShowInput: 0 },
    { id: 8,key: 'beauty_skincare', label: 'Beauty & Skincare', value: '', isShowInput: 0 },
    { id: 9,key: 'lifestyle', label: 'Lifestyle (e.g., home decor, parenting, relationships)', value: '', isShowInput: 0 },
    { id: 10,key: 'travel', label: 'Travel', value: '', isShowInput: 0 },
    { id: 11,key: 'food_beverage', label: 'Food & Beverage', value: '', isShowInput: 0 },
    { id: 12,key: 'technology', label: 'Technology', value: '', isShowInput: 0 },
    { id: 13,key: 'fitness_wellness', label: 'Fitness & Wellness', value: '', isShowInput: 0 },
    { id: 14,key: 'finance_investing', label: 'Finance & Investing', value: '', isShowInput: 0 },
    { id: 15,key: 'entertainment', label: 'Entertainment (e.g., movies, TV, music, gaming)', value: '', isShowInput: 0 },
    { id: 16,key: 'education_career', label: 'Education & Career', value: '', isShowInput: 0 },
    { id: 17,key: 'other_social', label: 'Other', value: '', isShowInput: 1 }
]
} ;
const contentFormat={
    'type':'preferred_content',
    'label':'Please specify',
    'title':'What is your preferred content format?',
    'options':[
        {id:25,key:'in_feed_photos',label:'In-feed photos',value:'',isShowInput:0},
        {id:26,key:'short_form_video',label:'Short-form video (Reels)',value:'', isShowInput:0},
        {id:27,key:'ig_stores',label:'IG stories',value:'',isShhowInput:0},
        {id:28,key:'ig_titok_live',label:'IG/TikTok Live',value:'',isShowInput:0},
        {id:29,key:'other_content_format',value:'',label:'Other',isShowInput:1}
    ]
};
const programmeOptions = {
    'type':'programme',
    'label':'WHAT IS THEIR INSTAGRAM HANDLE?',
    'title':'How did you hear about SK Brand Ambassadors Programme?',
    'options':[
    { id: 18,key: 'search_engine', label: 'Search Engine', value: '', isShowInput: 0 },
    { id: 19,key: 'ads', label: 'Ads', value: '', isShowInput: 0 },
    { id: 20,key: 'sk_website', label: 'SK Website', value: '', isShowInput: 0 },
    { id: 21,key: 'sk_social_platforms', label: 'SK Social Platforms', value: '', isShowInput: 0 },
    { id: 22,key: 'email', label: 'Email', value: '', isShowInput: 0 },
    { id: 23,key: 'word_of_wisdom', label: 'Word of Mouth', value: '', isShowInput: 0 },
    { id: 24,key: 'other_programme', label: 'Ambassadors Referral', value: '', isShowInput: 1 },
]
}
const title_form = computed(() => props.data_title);
const description = computed(() => props.data_description);
const siteKey_recapcha = computed(() => props.data_key);
const post_id_form = computed(() => props.data_postId);
const userStore = useUserStore();

const submitForm = async (value) => {
    responseMessage.value = '';
    if(!validateForm()){
        setTimeout(() => {
            const firstErrorElement = document.querySelector(".error");

            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: "smooth", block: "center" });
            } else {
                const formElement = document.getElementById("ambassador_form");
                if (formElement) {
                    formElement.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }
        }, 100);
        return;
    };

    if (recaptchaRef.value){
        recaptchaRef.value.getToken();
    }
    if (!form.value.recaptcha) {
        return;
    }

    const groupButton: NodeListOf<HTMLInputElement> = document.querySelectorAll('.gender-button.active');
    const groupButtonValue = Array.from(groupButton).map((checkbox)=> {
        return checkbox.getAttribute('data-value').trim();
    })

    const formattedData = new FormData();
    formattedData.append('email', form.value.email);
    formattedData.append('full_name', form.value.name);
    formattedData.append('gender', groupButtonValue.includes('Male') ? 'Male' : 'Female');
    formattedData.append('birthday', form.value.date);
    formattedData.append('phone', form.value.phone);
    formattedData.append('recaptcha', form.value.recaptcha);

    form.value.social_content.forEach(content => {
        formattedData.append('kind_of_social_content[]', content.label);
    });

    formattedData.append('orther_kind_of_social_content', form.value?.other_social || '');
    form.value.programme.forEach(content => {
        formattedData.append('brand_programme[]', content.label);
    });

    formattedData.append('instagram_their', form.value?.other_programme || '');
    form.value.preferred_content.forEach(content => {
        formattedData.append('preferred_content[]', content.label);
    });

    formattedData.append('orther_preferred_content', form.value?.other_content_format || '');
    formattedData.append('type_of_metal_color', groupButtonValue.includes('Yellow Gold') ? 'Yellow Gold' : 'Diamond');
    formattedData.append('type_of_jewellery', groupButtonValue.includes('Yes') ? 'Yes' : 'No');
    formattedData.append('reason_why', form.value.tell_us);
    formattedData.append('post_specific_id', form.value.post_id);
    formattedData.append('action', 'kform_submit');
    formattedData.append('form_id', 'ambassador_form');
    formattedData.append('post_id', post_id_form.value);

    form.value.social.forEach((social, index) => {
        let socialValue = form.value[social.value] || '';
        formattedData.append('custom_social[]', `${social.label} Account`);
        formattedData.append(`custom_social_${index}`, socialValue);
    });

    for (let i = form.value.social.length; i < 6; i++) {
        formattedData.append(`custom_social_${i}`, '');
    }


    try {
        isSubmitting.value = true;
        const response = await $ajax.post('wp-json/skj/v1/submit_kform', formattedData, {
            headers: {
                'Accept': 'application/json',
                "Authorization": `Bearer ${userStore.csrf}`,
            }
        });
        if(response.result.success) {
            pushToDataLayer('book_appointment');
            check_sub.value = true;
            responseMessage.value = response.message || 'Thank you for expressing your interest in becoming an SK Jewellery Brand Ambassador! We’re thrilled to receive your submission and will review it carefully. Should you be selected, we’ll reach out to you via email with the next steps.';
            setTimeout(() => {
                const ambassadorForm = document.getElementById("ambassador_form");
                if (ambassadorForm) {
                    ambassadorForm.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        }
    }catch (error) {
        console.log('error',error);
    }finally {
        isSubmitting.value = false;
    }
};

    watch(
        () => props.data_key,
        (newKey) => {
            if (newKey) {
                setTimeout(() => {
                    siteKey_recapcha.value = newKey; // Set siteKey after 1s delay
                }, 200); // 1-second delay
            }
        },
        { immediate: true }
    );
    const formClicked = ref(false);
    const startLoadRecaptcha = () => {
        if (recaptchaRef.value){
            if(!formClicked.value){
                // loadRecaptchaScript(); // Call the function to load reCAPTCHA script
                recaptchaRef.value.loadRecaptchaScript();
                // Add a delay before attempting to retrieve the token
                setTimeout(async () => {
                    try {
                    const token = await recaptchaRef.value.getToken();
                    // Optionally store or use the token
                    } catch (error) {
                    console.error('Error fetching reCAPTCHA token:', error);
                    }
                }, 500);
            }
        }
        formClicked.value = true
    }

const clearFieldError = (field: string) => {
    errors.value[field] = null;
};
const form = ref<FormState>({
    post_id: post_id_form,
    form_id: 'ambassador_form',
    email: '',
    name: '',
    date: '',
    phone: '',
    tell_us:'',
    social: [],
    social_content: [],
    preferred_content:[],
    programme: [],
    recaptcha: '',

});
interface other_social {
    value: string;
    key: string;
}
interface FormState {
    post_id: any;
    form_id: string;
    email: string;
    name: string;
    date: string;
    phone: string;
    tell_us: string;
    social: string[];
    social_content: other_social[];
    preferred_content:string[];
    programme: other_social[];
    recaptcha: string;
    [key: string]: any;
}
const errors = ref<{ [key: string]: string | null }>({
    email: null,
    name: null,
    date: null,
    phone: null,
    social: null,
    social_content: null,
    preferred_content: null,
    programme: null,
    tell_us: null,
});
const error_social = ref<{ [key: string]: string | null }>({
    instagram:null,
    tiktok:null,
    xiao_hong_shu:null,
    youtube:null,
    lemon8:null,
    douyin:null
})
const isValidDate = (date: Date) => {
  return !isNaN(new Date(date).getTime());
};
const validateForm = () => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phonePattern = /^[0-9]{11,12}$/;
  let isValid = true;
  Object.keys(form.value).forEach((field) => {
    const value = form.value[field as keyof FormState];
    if (field === 'email') {
        if (!value) {
            errors.value[field] = 'Please enter your email';
            isValid = false;
        } else if (!emailPattern.test(value)) {
            errors.value[field] = 'Please enter a valid email address';
            isValid = false;
        } else {
            errors.value[field] = null;
        }
        return;
        };
        if (field === 'other_programme') {
            if (!value) {

                errors.value['other_programme'] = 'Please enter your specify option';
                isValid = false;
            }
            else {
                errors.value[field] = null;
            }
        };
        if (field === 'phone') {
        if (!value) {
            errors.value[field] = 'Please enter your Mobile Number';
            isValid = false;
        } else if (!phonePattern.test(value)) {
            errors.value[field] = 'Length is 11 - 12 characters';
            isValid = false;
        } else {
            errors.value[field] = null;
        }
        return;
        };
        if(field === 'recaptcha'){
            errors.value['recaptcha'] = null;
            return;
        }
        if (field === 'date') {
            if (!value) {
                errors.value['date'] = 'Please enter your date of birth';
                isValid = false;
            }
            else {
                errors.value[field] = null;
            }
        }
        if (field === 'social') {
            if (value.length === 0) {
                errors.value['social'] = 'Please choose at least one option';
                isValid = false;
                return
            }
        Object.keys(value).forEach((socialField) => {
            const socialValue = value[socialField];
            if (!socialValue.value) {
            error_social.value[socialValue.key] = `Please enter your ${socialValue.label} handle`;
            isValid = false;
            } else {
            error_social.value[socialValue.key] = null;
            }
        });
          console.error(error_social.value, 'error_social');
        }

        if (!form.value.name) {
            errors.value.name = 'Please enter your name';
            isValid = false;
        }
        if (!form.value.tell_us) {
            errors.value.tell_us = 'Please fill in this field';
            isValid = false;
        }
        if (field==='recaptcha') {
            errors.value['recaptcha'] = null;
            return
        }
        if ((Array.isArray(value) && value.length === 0) || !value) {
        errors.value[field] = `Please choose at least one option`;
        if(field==='date') errors.value['date'] = `Please enter your date of birth`
        if(field==='other_programme') errors.value['other_programme'] = `Please enter your specify option`
        if(field==='other_social') errors.value['other_social'] = `Please enter your specify option`
        if(field==='other_content_format') errors.value['other_content_format'] = `Please enter your specify option`
        if(field==='instagram') error_social.value['instagram'] = `Please enter your Instagram handle`
        if(field==='tiktok') error_social.value['tiktok'] = `Please enter your Tiktok handle`
        if(field==='xiao_hong_shu') error_social.value['xiao_hong_shu'] = `Please enter your XiaoHongShu handle`
        if(field==='youtube') error_social.value['youtube'] = `Please enter your Youtube handle`
        if(field==='lemon8') error_social.value['lemon8'] = `Please enter your Lemon8 handle`
        if(field==='douyin') error_social.value['douyin'] = `Please enter your Douyin handle`
            isValid = false;
        }  else {
            errors.value[field] = null;
            error_social.value[field] = null;
        }
    });
    const allNull = Object.values(errors.value).every(value => value === null);
    return allNull;
};
onMounted(() => {
})
</script>
<style lang="scss" >
.master-template__ambassador-fields {



    &::-webkit-scrollbar {
        width: 8px;
        max-height: 10% !important;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 10px;
    }
    &::-webkit-scrollbar-track {
        background: #e5e4e4;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
// }
}
.ambassador-custom{
    label{
        margin-bottom: 5px !important;
    }
}
.dp--clear-btn{
    display: none;
}
.loading{
    margin-left: 10px;
    &:after {
        animation: button-loading-spinner 1s ease infinite;
        border: 4px solid transparent;
        border-radius: 50%;
        border-top-color: #555454;
        bottom: 0;
        content: "";
        height: 16px;
        left: 0;
        margin: auto;
        position: absolute;
        right: 0;
        top: 0;
        width: 16px;
      }
}
#ambassador_form {
    .alt-form-group {
        margin-bottom:16px;
    }
    &.submit_ss{
        .alt-form-group {
            display: none;
        }
        .master-template__form--field-set {
            display: none;
        }
        .altform-submit-group {
            display: none;
        }
        .success-message{
            display: block;
        }
    }

    .success-message {
        padding: 15px 35px;
        border-radius: 5px;
        margin-top: 30px;
        display: none;
    }
}
</style>